// @flow

import {
  onlyWhenSupport,
  type UserInputValidationError,
  type UserInputValidatorArgs,
  VALID,
} from '@tectonics/prs/validation';
import {
  getCurrentPaymentMethodOptionalFields,
  hasOptionalField,
} from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';
import {validateIndiaState} from '@tectonics/prs/india/validation/india-state';
import {getCurrentFeatures} from '@tectonics/prs/payment-spec';
import {validateIndiaAddress} from '@tectonics/prs/india/validation/india-address';
import {validateIndiaPhone} from '@tectonics/prs/india/validation/india-phone';
import {validateIndiaStreetNumber} from '@tectonics/prs/india/validation/india-street-number';
import {validateIndiaZipcode} from '@tectonics/prs/india/validation/india-zipcode';
import {validateIndiaCity} from '@tectonics/prs/india/validation/india-city';
import {validateIndiaCustomerName} from '@tectonics/prs/india/validation/india-customer-name';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  let optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  if (userInputName === 'indiaUpiApp' && userInputValues.selectedPaymentMethod === 'ewallet' && userInputValues.selectedEWallet === 'upi-intent') {
    return !userInputValue ?? null;
  }

  switch (userInputName) {
    case 'indiaCustomerName':
      if (!hasOptionalField(optionalFields, 'customer_name')) { 
        return onlyWhen('field_india_customer_name') && validateIndiaCustomerName(userInputValue);
      }
      return null;

    case 'indiaState':
      if (!hasOptionalField(optionalFields, 'state')) {
        return onlyWhen('field_india_state') && validateIndiaState(userInputValue);
      }
      return null;

    case 'indiaAddress':
      if (!hasOptionalField(optionalFields, 'address')) {
        return onlyWhen('field_india_address') && validateIndiaAddress(userInputValue);
      }
      return null;

    case 'indiaPhoneNumber':
      if (!hasOptionalField(optionalFields, 'phone_number')) {
        return onlyWhen('field_india_phone_number') && validateIndiaPhone(userInputValue);
      }
      return null;

    case 'indiaStreetNumber':
      if (!hasOptionalField(optionalFields, 'street_number')) {
        return onlyWhen('field_india_street_number') && validateIndiaStreetNumber(userInputValue);
      }
      return null;

    case 'indiaZipcode':
      if (!hasOptionalField(optionalFields, 'zipcode')) {
        return onlyWhen('field_india_zipcode') && validateIndiaZipcode(userInputValue);
      }
      return null;

    case 'indiaCity':
      if (!hasOptionalField(optionalFields, 'city')) {
        return onlyWhen('field_india_city') && validateIndiaCity(userInputValue);
      }
      return null;

    default:
      return VALID;
  }
}
